import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getAnnouncements=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_ANNOUNCEMENTS_START
    })
    const options={
        url:`${api}/announcements`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_ANNOUNCEMENTS_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_ANNOUNCEMENTS_FAIL,
                payload:getMessage(error)
            }))
}